import React, { useCallback, useEffect } from 'react';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import EyeButton from '../../../../components/eye-button/EyeButton';
import SonarSettings from '../../../../header/components/sonar-dashboard/SonarSettings';
import { changeDedicatedTablesVisibility, toggleDedicatedTables } from '../../../../redux/sonar/sonarReducer';
import SonarDatePicker from '../../../../header/components/sonar-dashboard/date-picker/SonarDatePicker';
import ConsumerHeader from '../../../consumer-header/ConsumerHeader';

import scss from './Header.module.scss';

const Header = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('header');
  const isMobile = useMediaQuery('(max-width: 600px)');

  const isShowDedicated = useSelector((state) => state.sonarDashboard.isShowDedicated);

  const toggleTable = useCallback(() => {
    dispatch(toggleDedicatedTables());
  }, [dispatch]);

  useEffect(() => {
    if (isMobile) {
      dispatch(changeDedicatedTablesVisibility(true));
    }
  }, [isMobile, dispatch]);

  return (
    <ConsumerHeader
      AdditionalActions={
        <>
          <SonarSettings />
          {!isMobile ? (
            <div className={scss.slimTableWrapper}>
              <EyeButton onClick={toggleTable} isActive={isShowDedicated} />
              <span className={scss.slimTableLabel}>{t('slimTables')}</span>
            </div>
          ) : null}
        </>
      }>
      <div>
        <SonarDatePicker />
      </div>
    </ConsumerHeader>
  );
};

export default Header;
